<script>
import {nextTick, onMounted, ref, toRaw, watch} from 'vue'
import { useIntervalFn } from '@vueuse/core'

import Alert from '@/components/Alert'
import LoadingCard from '@/components/LoadingCard'
import Step1 from '@/components/View/Step1'
import Step2 from '@/components/View/Step2'
import SuccessInvoicePayment from '@/components/View/SuccessInvoicePayment'
import CreditNotification from '../../VueShared/components/CreditNotification'
import { clientDataFields } from '@/stores/clientDataFields'
import { init, globalMessage, expiresAt, setExpiresAt, settings } from './stores/basket'
import { products } from './stores/product'
import { step, setStep } from './stores/view'
import _forEach from "lodash/forEach";
import { saveClientData, setClientDataValue } from '@/stores/clientData'

export default {
  components: {
    Alert,
    LoadingCard,
    Step1,
    Step2,
    SuccessInvoicePayment,
    CreditNotification,
  },
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      await init()

      if(settings.value.partner_data){
        let firstName = ''
        let lastName = ''

        if(settings.value.partner_data.contact_name){
          const contactNameParts = toRaw(settings.value.partner_data.contact_name.split(' '))
          if (contactNameParts.length > 1){
            lastName = contactNameParts.pop();
            firstName = contactNameParts.join(' ');
          }
        }

        const partnerFillData = {
          name: firstName,
          surname: lastName,
          firmName: settings.value.partner_data.company_name,
          firmCode: settings.value.partner_data.company_code,
          email: settings.value.partner_data.email,
          phone: settings.value.partner_data.phone,
          recipient: settings.value.partner_data.company_name || settings.value.partner_data.company_code ? 'jur' : 'era'
        }

        let needToSave = false

        setClientDataValue('recipient', partnerFillData['recipient'])

        _forEach(clientDataFields.value, field => {
          if(!field.value && partnerFillData[field.name]){
            setClientDataValue(field.name, partnerFillData[field.name])

            needToSave = true
          }
        })

        if(needToSave){
         setTimeout(() => saveClientData(), 50)
        }
      }

      loading.value = false

      let lastExpiresAt = null
      useIntervalFn(() => {
        if (
          expiresAt.value &&
          Date.now() >= expiresAt.value &&
          lastExpiresAt !== expiresAt.value
        ) {
          setTimeout(() => {
            init()
            setStep(1)
          }, 2500)
          setExpiresAt(0)
          lastExpiresAt = expiresAt.value
        }
      }, 1000)

      watch(
        expiresAt,
        (time) => {
          if (time) {
            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_purchase_timer',
                expires_at: time,
              }),
              '*'
            )
          } else {
            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_purchase_timer',
                expires_at: null,
              }),
              '*'
            )
          }
        },
        {
          immediate: true,
        }
      )

      watch(
        products,
        (products) => {
          if (!products.length) {
            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_purchase_timer',
                expires_at: null,
              }),
              '*'
            )

            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_hide_preview',
              }),
              '*'
            )
          } else {
            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_show_preview',
                items: products,
              }),
              '*'
            )
          }
        },
        {
          immediate: true,
        }
      )
    })

    const mainContainer = ref()
    const scrollView = (step) => {
      document.getElementById('content_b').style.display =
          step > 1 ? 'none' : ''

      if (mainContainer.value) {
        nextTick(() => {
          if (
              (document.documentElement.scrollTop || document.body.scrollTop) >
              300
          ) {
            window.scroll({
              behavior: 'smooth',
              left: 0,
              top: mainContainer.value.offsetTop - 300,
            })
          }
        })
      }
    }
    watch(
      step,
      (step) => {
        scrollView(step)
      },
      {
        immediate: true,
      }
    )

    window.addEventListener(
        "message",
        (event) => {
          if(event.data?.method === 'scrollShopBasketView'){
            scrollView(event.data?.step || 1)
          }
        })

    return {
      mainContainer,
      loading,
      globalMessage,
      products,
      step,
    }
  },
}
</script>

<template>
  <LoadingCard v-if="loading" />

  <Alert v-else-if="globalMessage">{{ globalMessage }}</Alert>

  <Alert v-else-if="!products.length">{{ __('basket_is_empty') }}</Alert>

  <div ref="mainContainer" v-else>
    <Step1 v-if="step === 1" />
    <Step2 v-else-if="step === 2" />
    <SuccessInvoicePayment v-else-if="step === 3" />
  </div>

  <CreditNotification />
</template>
